var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecoIco5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 -8.43806e-06C28.7173 -8.88467e-06 37 8.28272 37 18.5C37 28.7173 28.7173 37 18.5 37C8.28273 37 -3.6205e-07 28.7173 -8.08661e-07 18.5C-1.25527e-06 8.28273 8.28273 -7.99144e-06 18.5 -8.43806e-06Z",
    fill: "#D7922A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecoIco5);
export default __webpack_public_path__ + "static/media/decoIco5.85f103ebf8fc90244c2aa566ec06576e.svg";
export { ForwardRef as ReactComponent };